import * as React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import Clock from 'common/app/Launcher/Clock';

export default ({ lang, clock}: any) => ({
    key: 'CLOCK',
    title: <Tooltip title={<Clock className="Launcher-clock" lang={lang} {...clock} />}>
            <ClockCircleOutlined style={{ fontSize: 15 }} />
        </Tooltip>
});
